import { CSSProperties } from 'react';
import { theme } from '../../theme';

export const addPaymentMethodCardStyles = {
  button: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 184,
    padding: theme.spacing.large,
    gap: theme.spacing.extraSmall,
    backgroundColor: theme.colors.card.light,
    border: `1.5px dashed ${theme.colors.card.borderDashed}`,
    borderRadius: theme.radius.md,
    cursor: 'pointer',
    transition: `all ${theme.transitions.normal}`,
    fontFamily: theme.typography.fontFamily,
  } as CSSProperties,

  webButton: {
    background: 'none',
    borderColor: theme.colors.palette.blue100,
    height: 184,
  } as CSSProperties,

  /** Web, sin seleccionar: 122 px de alto. */
  webButtonCollapsed: {
    minHeight: 122,
    height: 122,
    padding: theme.spacing.medium,
  } as CSSProperties,

  buttonDisabled: {
    cursor: 'not-allowed',
    opacity: 0.5,
  } as CSSProperties,

  cta: {
    aglignItems: 'center',
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing.extraSmall,
  } as CSSProperties,

  ctaText: {
    color: theme.colors.palette.blue100,
    fontWeight: theme.typography.fontWeight.bold,
  } as CSSProperties,

  iconBox: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
    backgroundColor: theme.colors.palette.lightBlue200,
    width: theme.spacing.semiHugeXl,
    height: theme.spacing.largeXl,
    borderRadius: theme.spacing.mediumLargeXl,
  } as CSSProperties,

  icon: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: theme.typography.fontWeight.medium,
    textAlign: 'center',
    color: theme.colors.button.primary,
    fontSize: 24,
    lineHeight: theme.typography.lineHeight.xl,
  } as CSSProperties,

  text: {
    textAlign: 'center',
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.fontSize.sm,
    lineHeight: theme.typography.lineHeight.sm,
    color: theme.colors.palette.neutral650,
    maxWidth: theme.spacing.gigantic, // 180
    margin: 0,
  } as CSSProperties,
};
